import { theme } from '@/styles';
import MarkerIcon from '@/ui/Icons/MarkerIcon';
import { SearchShop } from '@remodeling/shop';
import React from 'react';
import styled from 'styled-components';

const OverlayBox = ({
  item,
  currentHover,
  ...props
}: {
  item: SearchShop;
  currentHover: number;
}) => {
  const isHover = currentHover === item.id;
  const iconProps = {
    isHover,
    groupCode: item.type.groupCode,
  };

  return (
    <MarkerContainer {...props}>
      {isHover ? (
        <Container>
          <MarkerIcon
            {...iconProps}
            fill={theme.colors.accent_colors.blue.default}
          />

          <StoreName>{item.name}</StoreName>
          <ArrowIcon></ArrowIcon>
        </Container>
      ) : (
        <MarkerBox>
          <IconBox>
            <MarkerIcon
              {...iconProps}
              fill={theme.colors.accent_colors.primary.default}
            />
          </IconBox>
        </MarkerBox>
      )}
    </MarkerContainer>
  );
};

export default OverlayBox;

const MarkerContainer = styled.div`
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  padding: 3px 12px 3px 0px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.accent_colors.primary.default};
  height: 46px;
  z-index: 999;
  align-items: center;
  background-color: ${theme.colors.neutral_colors.white};
  svg {
    position: relative;
    left: -2px;
  }
`;

const ArrowIcon = styled.div`
  height: 18px;
  width: 12px;
  position: absolute;
  bottom: -18px;
  left: 35px;
  border-bottom: 0px solid transparent;
  border-top: 8px solid ${theme.colors.accent_colors.primary.default};
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
`;

const StoreName = styled.div`
  max-width: 208px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.button.lg_b};
`;

const IconBox = styled.div`
  width: 49px;
  height: 49px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    position: relative;
    top: -1px;
    left: -1px;
  }
`;

const MarkerBox = styled.div`
  width: 49px;
  height: 50px;
`;
